import { Reveal, Overline } from "@/lib/Reveal";
import { IMAGES } from "@/lib/site";

const CHAPTERS = [
    {
        n: "01",
        title: "Quality Workmanship",
        text: "Every job — from a single repair to a full renovation — is completed to a standard we are proud to put our name to.",
    },
    {
        n: "02",
        title: "Reliable Service",
        text: "We turn up when we say we will, keep you informed throughout, and treat your home with the respect it deserves.",
    },
    {
        n: "03",
        title: "Attention to Detail",
        text: "Preparation, precision and a clean finish. The details are where good work becomes great work.",
    },
    {
        n: "04",
        title: "Practical Smart Solutions",
        text: "We solve property problems sensibly — practical improvements that make your home work better for you.",
    },
    {
        n: "05",
        title: "Local Luton Service",
        text: "Based at the heart of Luton, we serve homeowners, landlords and property managers across the town and surrounding areas.",
    },
];

export default function AboutManifesto() {
    return (
        <section id="about" data-testid="about-section" className="py-20 lg:py-28 bg-[#FAFAFA]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                    <div className="lg:col-span-5">
                        <div className="lg:sticky lg:top-28">
                            <Reveal>
                                <Overline>About Appex Smart Solution</Overline>
                                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-neutral-900 mt-4 leading-[1.05]">
                                    A smarter way to care for your property
                                </h2>
                                <p className="mt-6 text-base text-neutral-600 leading-relaxed">
                                    Appex Smart Solution provides reliable construction, maintenance and home improvement
                                    services for homeowners, landlords and property owners across Luton. One call, one
                                    team, and a professional approach from first quote to final finish.
                                </p>
                            </Reveal>
                            <Reveal delay={0.15}>
                                <div className="mt-10 relative rounded-2xl overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.14)]">
                                    <img
                                        src={IMAGES.about}
                                        alt="Property maintenance professional at work on a Luton home"
                                        className="w-full h-72 sm:h-80 object-cover"
                                        loading="lazy"
                                    />
                                    <div className="absolute bottom-0 inset-x-0 bg-[#141414]/85 backdrop-blur-sm px-6 py-4">
                                        <p className="font-mono-brand text-[11px] uppercase tracking-[0.22em] text-[#E85A1D] font-semibold">
                                            17 Ames Close · Luton · LU3 4AS
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        {CHAPTERS.map((c, i) => (
                            <Reveal key={c.n} delay={i * 0.06}>
                                <div
                                    data-testid={`manifesto-chapter-${c.n}`}
                                    className="group grid grid-cols-[auto_1fr] gap-6 sm:gap-10 py-8 sm:py-10 border-t border-[#E5E5E0] last:border-b transition-colors duration-300 hover:bg-[#FFF1EB]/60 rounded-lg px-2 sm:px-4 -mx-2 sm:-mx-4"
                                >
                                    <span className="font-mono-brand text-sm sm:text-base font-semibold text-[#E85A1D] pt-1.5">
                                        {c.n}
                                    </span>
                                    <div>
                                        <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 transition-transform duration-300 group-hover:translate-x-1.5">
                                            {c.title}
                                        </h3>
                                        <p className="mt-3 text-sm sm:text-base text-neutral-600 leading-relaxed max-w-xl">
                                            {c.text}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
